export default {
  path: '/wap',
  component: () => import('@/page/Wap/wap'),
  children: [
    {
      path: 'login',
      name: 'WapLogin',
      component: () => import('@/page/Wap/login')
    },
    {
      path: 'show',
      name: 'WapShow',
      component: () => import('@/page/Wap/show')
    },
    {
      path: 'modelShow',
      name: 'ModelShow',
      component: () => import('@/page/Wap/modelShow')
    },
    {
      path: 'designShow',
      name: 'DesignShow',
      component: () => import('@/page/Wap/designShow.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/wap.js